import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-mentions-legales',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './mentions-legales.html',
  styleUrls: ['./mentions-legales.scss']
})
export class MentionsLegalesComponent {}
